export const Text = {
  baseStyle: {
    fontSize: '16px',
  },
  variants: {
    default: {
      color: 'text.primary',
    },
    primary: {
      color: 'brand.primary',
    },
    secondary: {
      color: 'brand.secondary',
    },
    header: {
      color: 'brand.header',
    },
    accent: {
      color: 'brand.accent',
    },
    white: {
      color: 'brand.white',
    },
    error: {
      color: 'brand.error',
    },
    card: {
      color: 'brand.card-font',
    },
    epink: {
      color: 'brand.black',
    },
    contrast: {
      color: 'brand.contrast',
    },
  },
  // The default variant values
  defaultProps: {
    variant: 'default',
  },
}
